// extracted by mini-css-extract-plugin
export default {"container":"UL-z","title":"VL-z","link":"WL-z"};